var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main"}},[_c('div',{staticClass:"container py-4 py-lg-4"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.projects),function(project){return _c('div',{key:project.title,staticClass:"row"},[_c('pub-card',_vm._b({},'pub-card',project,false))],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }